import {Component, Injector, OnInit} from "@angular/core";
import {BasicMaterialDialog} from "../../basic-material-dialog/basic-material-dialog.directive";
import {MEDIA_DIALOG_BASE_INPUT} from "../media-image-dialog/media-image-dialog.component";

@Component({
	selector: "sim-media-pdf-dialog",
	templateUrl: "./media-pdf-dialog.component.html",
	styleUrls: ["./media-pdf-dialog.component.scss"],
	standalone: false,
})
export class MediaPdfDialogComponent extends BasicMaterialDialog<MediaPdfDialogComponent, MEDIA_DIALOG_BASE_INPUT> implements OnInit {
	constructor(_injector: Injector) {
		super(_injector);
	}

	public stop() {
		this.close({action: "ok"});
	}

	public cancel() {
		this.close({action: "cancel"});
	}
}
